import { useEffect } from 'react';
import { InternalSupportMessage, InternalSupportTicket } from '../helpers/internal-support.types';
import {
    getInternalSupportSocket,
    joinInternalSupportTicketRoom,
    leaveInternalSupportTicketRoom,
} from '../services/internal-support.socket';

interface UseInternalSupportTicketSocketProps {
    ticketId: string | undefined;
    onMessage: (message: InternalSupportMessage) => void;
    onTicketUpdated: (ticket: InternalSupportTicket) => void;
}

const useInternalSupportTicketSocket = ({
    ticketId,
    onMessage,
    onTicketUpdated,
}: UseInternalSupportTicketSocketProps) => {
    useEffect(() => {
        if (!ticketId) return;

        const socket = getInternalSupportSocket();
        joinInternalSupportTicketRoom(ticketId);

        const handleMessage = (message: InternalSupportMessage) => {
            onMessage(message);
        };

        const handleTicketUpdated = (ticket: InternalSupportTicket) => {
            onTicketUpdated(ticket);
        };

        socket.on('pulse-internal-ticket:message', handleMessage);
        socket.on('pulse-internal-ticket:updated', handleTicketUpdated);

        return () => {
            socket.off('pulse-internal-ticket:message', handleMessage);
            socket.off('pulse-internal-ticket:updated', handleTicketUpdated);
            leaveInternalSupportTicketRoom(ticketId);
        };
    }, [ticketId, onMessage, onTicketUpdated]);
};

export default useInternalSupportTicketSocket;
